export const USER_INVITE_ERROR_CODES = {
  not_found: 'not_found',
  invite_already_accepted: 'invite_already_accepted',
  invite_discarded: 'invite_discarded',
  all_seats_taken: 'all_seats_taken',
} as const;
export type UserInviteErrorCode =
  (typeof USER_INVITE_ERROR_CODES)[keyof typeof USER_INVITE_ERROR_CODES];

export const USER_AUTHENTICATE_ERROR_CODES = {
  user_has_no_customer: 'user_has_no_customer',
} as const;
export type UserAuthenticateErrorCode =
  (typeof USER_AUTHENTICATE_ERROR_CODES)[keyof typeof USER_AUTHENTICATE_ERROR_CODES];

export const UPDATE_CUSTOMER_ERROR_CODES = {
  customer_name_taken: 'customer_name_taken',
} as const;
export type UpdateCustomerErrorCode =
  (typeof UPDATE_CUSTOMER_ERROR_CODES)[keyof typeof UPDATE_CUSTOMER_ERROR_CODES];

export const RESOURCE_ERROR_CODES = {
  resourceFileAlreadyExist: 'resource_file_already_exist',
  resourceFileNotEnoughContent: 'resource_file_not_enough_content',
} as const;
export type ResourceErrorCode = (typeof RESOURCE_ERROR_CODES)[keyof typeof RESOURCE_ERROR_CODES];

export const GRAPHQL_ERROR_CODES = {
  ...USER_INVITE_ERROR_CODES,
  ...USER_AUTHENTICATE_ERROR_CODES,
  ...UPDATE_CUSTOMER_ERROR_CODES,
  ...RESOURCE_ERROR_CODES,

  // The caller no longer has access, e.g. a reviewer of a project that is not shared any more.
  accessError: 'ACCESS_ERROR',

  // custom error codes
  undefined: 'undefined',
  networkError: 'networkError',
} as const;
export type GraphQLErrorCode = (typeof GRAPHQL_ERROR_CODES)[keyof typeof GRAPHQL_ERROR_CODES];
